import { actionCreator } from 'utils';
import {
    LOAD_JOB_RESULT,
    SET_JOB_RESULT_SORT,
    SET_JOB_RESULT_PAGINATION,
    SET_JOB_RESULT_FILTERS,
    RESET_JOB_RESULT_FILTERS,
    SET_CHECKED_JOB_RESULT,
    ADD_NEW_PALETTE,
    PRINT_PALETTE,
    SET_CHECKED_JOB_RESULT_RECORD,
    SHOW_ADD_NEW_PALETTE_POPUP,
    HIDE_ADD_NEW_PALETTE_POPUP,
    UPDATE_JOB_RESULTS,
    FORCE_PRINT_PALETTE,
    DELETE_JOB_RESULT,
    GENERATE_TEMPORARY_PAPER,
} from '../types/jobResultTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    paletteCreated: false,
    submitting: false,
    offset: 0,
    limit: 10,
    showAddNewPalette: false,
    deleteJobResultId: null,
    isDeletingJobResult: false,
    isGeneratingTemporaryPaper: false,
    sort: {
        key: 'created_at',
        type: 'desc',
    },

    checked: {
        loading: false,
        ids: [],
        selected: [],
    },

    filters: {
        id: '',
        job: '',
        form_version_id: '',
        form_id: '',
        design_id: '',
        order_item_id: '',
        order_id: '',
        po_number: '',
        paletteNumber: '',
        palette: '',
        roller_barcode: '',
        machine_ids: undefined,
        status: undefined,
    },
    update: {
        loading: false,
        success: false,
        error: false,
    },
    print_palette: {
        loading: false,
        success: false,
        error: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_JOB_RESULT:
        return Object.assign({}, state, {
            loading: true,
        });
    case actionCreator(LOAD_JOB_RESULT, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });
    case actionCreator(LOAD_JOB_RESULT, 'res'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            listing: action.data,
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case SET_JOB_RESULT_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_JOB_RESULT_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case SET_JOB_RESULT_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_JOB_RESULT_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case RESET_JOB_RESULT_FILTERS:
        return Object.assign({}, state, {

            ...state,
            loading: true,
            filters: initState.filters,
        });

    case actionCreator(RESET_JOB_RESULT_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case ADD_NEW_PALETTE:
        return Object.assign({}, state, {
            ...state,
            submitting: true,
        });

    case actionCreator(ADD_NEW_PALETTE, 'res'):
        return Object.assign({}, state, {
            ...state,
            submitting: false,
            paletteCreated: true,
        });

    case actionCreator(ADD_NEW_PALETTE, 'err'):
        return Object.assign({}, state, {
            paletteCreated: false,
            submitting: false,
        });

    case actionCreator(PRINT_PALETTE, 'res'):
        return Object.assign({}, state, {
            paletteCreated: false,
            showAddNewPalette: false,
            checked: {
                ...state.checked,
                loading: false,
                ids: [],
                selected: [],
            },
        });

    case actionCreator(PRINT_PALETTE, 'err'):
        return Object.assign({}, state, {
            paletteCreated: false,
            showAddNewPalette: false,
        });

    case SET_CHECKED_JOB_RESULT:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                ids: action.ids,
            },
        });

    case SET_CHECKED_JOB_RESULT_RECORD:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                selected: action.data,
            },
        });
    case SHOW_ADD_NEW_PALETTE_POPUP:
        return Object.assign({}, state, {
            paletteCreated: false,
            showAddNewPalette: true,
        });

    case HIDE_ADD_NEW_PALETTE_POPUP:
        return Object.assign({}, state, {
            showAddNewPalette: false,
            paletteCreated: false,
            checked: {
                ...state.checked,
                loading: false,
                ids: [],
                selected: [],
            },
        });

    case UPDATE_JOB_RESULTS:
        return Object.assign({}, state, {
            update: {
                ...state.update,
                loading: action.data,
                success: false,
                error: false,
            },
        });

    case actionCreator(UPDATE_JOB_RESULTS, 'res'):
        return Object.assign({}, state, {
            update: {
                ...state.update,
                loading: action.loading,
                success: action.success,
            },
        });

    case actionCreator(UPDATE_JOB_RESULTS, 'err'):
        return Object.assign({}, state, {
            update: {
                ...state.update,
                loading: false,
                success: false,
                error: true,
            },
        });

    case FORCE_PRINT_PALETTE:
        return Object.assign({}, state, {
            print_palette: {
                ...state.print_palette,
                loading: action.data,
                success: false,
                error: false,
            },
        });

    case actionCreator(FORCE_PRINT_PALETTE, 'res'):
        return Object.assign({}, state, {
            print_palette: {
                ...state.print_palette,
                loading: action.loading,
                success: action.success,
            },
        });

    case actionCreator(FORCE_PRINT_PALETTE, 'err'):
        return Object.assign({}, state, {
            print_palette: {
                ...state.print_palette,
                loading: false,
                success: false,
                error: true,
            },
        });

    case DELETE_JOB_RESULT:
        return Object.assign({}, state, {
            deleteJobResultId: action.id,
            isDeletingJobResult: false,
        });

    case actionCreator(DELETE_JOB_RESULT, 'res'):
        return Object.assign({}, state, {
            deleteJobResultId: null,
            isDeletingJobResult: false,
        });

    case actionCreator(DELETE_JOB_RESULT, 'err'):
        return Object.assign({}, state, {
            deleteJobResultId: null,
            isDeletingJobResult: false,
        });

    case GENERATE_TEMPORARY_PAPER:
        return Object.assign({}, state, {
            isGeneratingTemporaryPaper: false,
        });

    case actionCreator(GENERATE_TEMPORARY_PAPER, 'res'):
        return Object.assign({}, state, {
            isGeneratingTemporaryPaper: false,
        });

    case actionCreator(GENERATE_TEMPORARY_PAPER, 'err'):
        return Object.assign({}, state, {
            isGeneratingTemporaryPaper: false,
        });

    default:
        return state;
    }
}
